export const PHONE_SCREEN_HEIGHT = 518;
export const PHONE_SCREEN_BLOCKER_HEIGHT =
  (window.innerHeight - PHONE_SCREEN_HEIGHT) / 2;
export const PHONE_SCREEN_STICKY_BOTTOM_POSITION =
  PHONE_SCREEN_HEIGHT + PHONE_SCREEN_BLOCKER_HEIGHT;
export const PHONE_SCREEN_BORDER_RADIUS = 20;
